module.exports = {
  PENDING: 'pending',
  ROLLED: 'rolled',
};
